import ResponsiveTypography from '@/components/ui/responsive-typography';
import {UserInfosFormValues} from '@/redux-store/slices/user-infos';
import {Box, Grid, Paper, SxProps, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface CompanyInfosProps {
  userData: UserInfosFormValues;
  sx?: SxProps;
}
const CompanyInfosForTrainer: React.FC<CompanyInfosProps> = ({
  userData,
  sx
}) => {
  const {t} = useTranslation();
  const availableCompanies = userData.companies;

  const companyDataArray =
    availableCompanies &&
    Object.values(availableCompanies).map((company) => company.id);

  if (!availableCompanies || availableCompanies.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignContent="center">
        <ResponsiveTypography larger>
          {t('no_companies_trainer')}
        </ResponsiveTypography>
      </Box>
    );
  }

  return (
    <>
      <Grid justifyContent={'center'} alignContent={'center'}>
        <Paper elevation={3} sx={{p: 3, marginTop: 1}}>
          <Grid container spacing={3} sx={sx}>
            <Grid item xs={12}>
              <Typography
                sx={{whiteSpace: 'pre-line'}}
                variant="subtitle1"
                gutterBottom
              >
                {t('trainer_welcome_text')}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid
        marginBottom={6}
        marginTop={4}
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <ResponsiveTypography
            larger
            sx={{
              textAlign: 'center',
              marginBottom: 1
            }}
          >
            {t('your_companies')}
          </ResponsiveTypography>
        </Grid>

        {companyDataArray?.map((company, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            display="flex"
            justifyContent="center"
            alignContent="center"
            flexDirection="column"
            marginTop={3}
            key={index}
          >
            {company.logo && (
              <>
                <ResponsiveTypography
                  medium
                  sx={{
                    justifyContent: 'center',
                    alignSelf: 'center',
                    marginBottom: 1
                  }}
                >
                  {company.title}
                </ResponsiveTypography>
                <Box
                  component="img"
                  alt={t('company_logo')}
                  src={`${company.logo}?timestamp=${Date.now()}`}
                  sx={{
                    display: 'block',
                    mx: 'auto',
                    maxWidth: {xs: '250px', sm: '300px'},
                    maxHeight: {xs: '100px', sm: '120px'}
                  }}
                />
              </>
            )}
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default CompanyInfosForTrainer;
